import React, { useState } from 'react';
import { Loader2, Link as LinkIcon } from 'lucide-react';
interface UrlFetcherProps {
  onCardAdd: (card: {
    title: string;
    url: string;
    description: string;
    image: string;
    price?: string;
    status?: string;
  }) => void;
  sectionType: 'listings-videos' | 'custom-links';
}
export function UrlFetcher({
  onCardAdd,
  sectionType
}: UrlFetcherProps) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const mockFetchOgData = async (inputUrl: string) => {
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 1200));
    const urlLower = inputUrl.toLowerCase();
    let cardData: {
      title: string;
      url: string;
      description: string;
      image: string;
      price?: string;
      status?: string;
    };
    if (urlLower.includes('zillow') || urlLower.includes('realtor') || urlLower.includes('redfin')) {
      cardData = {
        title: '1428 Pacific Ave',
        url: inputUrl,
        description: '4 bed · 3.5 bath · 2,850 sqft',
        image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=200&h=200&fit=crop',
        price: '$2.45M',
        status: 'Active'
      };
    } else if (urlLower.includes('youtube') || urlLower.includes('vimeo')) {
      cardData = {
        title: 'Property Tour — Pacific Heights',
        url: inputUrl,
        description: 'Full walkthrough of this stunning 4BR home',
        image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=200&h=200&fit=crop'
      };
    } else {
      const domain = inputUrl.replace(/^https?:\/\//, '').split('/')[0];
      const domainName = domain.split('.')[0];
      cardData = {
        title: domainName.charAt(0).toUpperCase() + domainName.slice(1),
        url: inputUrl,
        description: `Link added from ${domain}`,
        image: ''
      };
    }
    setLoading(false);
    onCardAdd(cardData);
    setUrl('');
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (url.trim()) {
      mockFetchOgData(url.trim());
    }
  };
  return <form onSubmit={handleSubmit} className="flex items-center gap-2" data-id="element-259">
      <div className="flex-1 relative" data-id="element-260">
        <input type="text" value={url} onChange={e => setUrl(e.target.value)} placeholder="Paste a URL to auto-fetch details..." className="w-full bg-white border border-brand-light rounded-xl px-4 py-2.5 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors pl-10" disabled={loading} data-id="element-261" />
        <LinkIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" data-id="element-262" />
        {loading && <Loader2 size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-forest animate-spin" data-id="element-263" />}
      </div>
      <button type="submit" disabled={!url.trim() || loading} className="px-4 py-2.5 bg-brand-forest text-white rounded-xl text-sm font-medium hover:bg-brand-forestHover transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-264">
        Fetch
      </button>
    </form>;
}